/// <reference lib="dom" />
// Runs only in the web build (printing through an iframe); the native tsconfig has no DOM types.
/**
 * Prints a rendered DOM node on its own A4 page via a throwaway iframe - the
 * same technique the public website's CXC registration form uses
 * (publicWebsite/CaymanAcademy/.../printRegistrationForm.ts). react-native-web
 * ships its generated styles as <style> tags in <head> rather than inline
 * style attributes, so element.innerHTML alone loses all visual styling;
 * copying every stylesheet the app has loaded into the iframe is what keeps
 * the printed page looking like the screen.
 */
export function printRegistrationForm(element: HTMLElement | null, title: string): void {
  if (!element) {
    window.print();
    return;
  }

  try {
    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    document.body.appendChild(frame);

    const frameDoc = frame.contentDocument || frame.contentWindow?.document;
    if (!frameDoc) {
      window.print();
      return;
    }

    const inlineCss = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules).map((rule) => rule.cssText).join('\n');
        } catch {
          return '';
        }
      })
      .join('\n');

    const linkTags = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .map((el) => el.outerHTML)
      .join('\n');

    frameDoc.open();
    frameDoc.write(`<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>${title}</title>
    ${linkTags}
    <style>${inlineCss}</style>
    <style>
      * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
      @page { size: A4 portrait; margin: 10mm 12mm; }
      html, body { margin: 0; background: #ffffff; }
    </style>
  </head>
  <body>${element.innerHTML}</body>
</html>`);
    frameDoc.close();

    setTimeout(() => {
      frame.focus();
      frame.contentWindow?.focus();
      frame.contentWindow?.print();
      setTimeout(() => {
        if (document.body.contains(frame)) document.body.removeChild(frame);
      }, 1500);
    }, 450);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Print error:', err);
    window.print();
  }
}
